<template lang="pug">
  #ticker.page
    .columns.is-mobile
      .column.is-narrow-desktop.is-half-mobile.is-three-fifths-touch
        a
          span.tag.is-pulled-left.is-info.is-unselectable Processing: {{ matchCount }}
      .column
        .columns.is-mobile.has-text-right
          .column.is-narrow.is-hidden-touch(v-for="row of companyStatistic")
            button.button.is-small(
              :class="{ 'is-success': row.status }"
              @click="toggleFilter(row.id, $store.state.ticker.filters.companies)")
              span {{ row.name }} ({{ row.count }})
        .columns.is-mobile.is-multiline.has-text-right
          .column.is-half-tablet.is-hidden-desktop(v-for="row of companyStatistic")
            button.button.is-small.is-fullwidth(
              :class="{ 'is-success': row.status }"
              @click="toggleFilter(row.id, $store.state.ticker.filters.companies)")
              span {{ row.name }} ({{ row.count }})
    .columns.is-mobile
      .column.is-narrow-desktop.is-half-mobile.is-three-fifths-touch
        .title.is-5 Signals
      .column
        .columns.is-mobile.has-text-right
          .column.is-narrow.is-hidden-touch(v-for="row of signalStatistic")
            button.button.is-small(
              :class="{ 'is-success': row.status }"
              @click="toggleFilter(row.id, $store.state.ticker.filters.signals)")
                span {{ row.name }} ({{ row.count }})
        .columns.is-mobile.is-multiline.has-text-right
          .column.is-half-tablet.is-hidden-desktop(v-for="row of signalStatistic")
            button.button.is-small.is-fullwidth(
              :class="{ 'is-success': row.status }"
              @click="toggleFilter(row.id, $store.state.ticker.signals)")
              span {{ row.name }} ({{ row.count }})
    template(v-if="filteredMatches.length")
      TickerMatch(v-for="match in filteredMatches" :match="match" :source="source" :key="`${match._id}`")
    .notification(v-else)
      .content
        p No matches
    .title.is-5 Processing
    template(v-if="processingMatches.length")
      TickerMatch(v-for="match in processingMatches" :match="match" :source="source" :key="`${match._id}`")
    .notification(v-else)
      .content
        p No matches
</template>

<script>
import TickerMatch from "@/components/TickerMatch";

const SIGNAL_TYPE = {
  crash: "Crash",
  raise: "Raise",
  highTrended: "High Trended",
  lowTrended: "Low Trended",
  whale: "Whale",
  sharp: "Sharp"
};

export default {
  name: "ticker",
  components: {
    TickerMatch
  },
  computed: {
    matchCount() {
      return [
        ...this.$store.getters.tickerFilteredMatches,
        ...this.$store.getters.tickerProcessingMatches
      ].reduce((acc, { _id }) => acc.add(_id), new Set()).size;
    },
    source() {
      return this.$store.getters.getTickerSource;
    },
    matches() {
      return this.$store.getters.tickerMatches;
    },
    companyMap() {
      return this.$store.getters.companyMap;
    },
    filteredMatches() {
      return this.$store.getters.tickerFilteredMatches.filter(match =>
        match.historySignal.some(
          row =>
            (!this.$store.state.ticker.filters.companies.length ||
              this.$store.state.ticker.filters.companies.includes(
                row.companyId
              )) &&
            (!this.$store.state.ticker.filters.signals.length ||
              this.$store.state.ticker.filters.signals.includes(row.type))
        )
      );
    },
    companyStatistic() {
      const matches = this.$store.getters.tickerFilteredMatches;
      const companies = new Set(this.source.settings.matchList.companies);
      companies.add(this.source.settings.raiseBot.company);
      companies.add(this.source.settings.whenBot.company);
      return [...companies]
        .map(companyId => {
          if (!this.companyMap[companyId]) return false;
          return {
            id: companyId,
            name: this.companyMap[companyId].name,
            status: this.$store.state.ticker.filters.companies.includes(
              companyId
            ),
            count: matches.filter(match =>
              match.historySignal.some(row => companyId === row.companyId)
            ).length
          };
        })
        .filter(Boolean);
    },
    signalStatistic() {
      let matches = this.$store.getters.tickerFilteredMatches;
      return Object.keys(SIGNAL_TYPE).map(type => {
        return {
          id: type,
          name: SIGNAL_TYPE[type],
          status: this.$store.state.ticker.filters.signals.includes(type),
          count: matches.filter(match =>
            match.historySignal.some(row => {
              let companyOK = true;
              const typeOK = type === row.type;
              if (this.$store.state.ticker.filters.companies.length) {
                // eslint-disable-next-line fp/no-mutation
                companyOK = this.$store.state.ticker.filters.companies.includes(
                  row.companyId
                );
              }
              return companyOK && typeOK;
            })
          ).length
        };
      });
    },
    processingMatches() {
      return this.$store.getters.tickerProcessingMatches;
    }
  },
  methods: {
    toggleFilter(id, filter) {
      const i = filter.findIndex(_id => _id === id);
      if (i >= 0) {
        filter.splice(i, 1);
      } else filter.push(id);
    }
  }
};
</script>

<style lang="scss" scoped>
#ticker {
  .source-link {
    top: -5rem;
    padding: 1rem;
    color: $defaultColor;
    text-transform: uppercase;
    font-weight: bold;
    background: transparent;
    transition: all 0.2s linear;

    span:not(.icon) {
      font-size: 1.3rem;
    }

    .wrapper {
      border-bottom: 2px solid $brandColor;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
      color: lighten($brandColor, 20%);
    }
  }

  .tags {
    .tag {
      cursor: pointer;
      user-select: none;
    }
  }

  .columns {
    align-items: center;

    .has-text-right {
      flex-direction: row-reverse;
    }
  }
}
</style>
